import { FC, useMemo } from 'react';
import { List, CheckCircle2, XCircle } from 'lucide-react';
import { Assessment } from '@teachur/http-client';
import { useExamContext } from '@new/features/courses/contexts/ExamProvider';
import { isAssessmentCorrect } from '@new/features/courses/lib/assessmentHelpers';
import { ResultStatCard } from './ResultStatCard';

export const ResultStats: FC = () => {
  const { examMode } = useExamContext();
  const quiz = examMode.type === 'result' ? examMode.attempt : null;

  const userAnswerIds = useMemo(() => quiz?.answers?.map((a) => a.id) ?? [], [quiz?.answers]);

  const total = quiz?.assessments?.length ?? 0;
  const correct = useMemo(
    () =>
      quiz?.assessments?.filter((assessment: Assessment) =>
        isAssessmentCorrect(assessment, userAnswerIds)
      ).length ?? 0,
    [quiz?.assessments, userAnswerIds]
  );
  const incorrect = total - correct;

  return (
    <div className="flex items-center gap-3 justify-between self-center bg-(--primary-O100) w-full md:px-10 md:py-3 rounded-[12px]">
      <ResultStatCard
        icon={
          <List className="text-(--secondary-B800) w-5.5 h-5.5 md:w-9 md:h-9" strokeWidth={1.5} />
        }
        label="Total"
        value={total}
        bgColor="bg-(--secondary-B100)"
      />
      <ResultStatCard
        icon={
          <CheckCircle2
            className="text-(--success-S600) w-5.5 h-5.5 md:w-9 md:h-9"
            strokeWidth={1.5}
          />
        }
        label="Correct"
        value={correct}
        bgColor="bg-(--success-S200)"
      />
      <ResultStatCard
        icon={
          <XCircle className="text-(--danger-D600) w-5.5 h-5.5 md:w-9 md:h-9" strokeWidth={1.5} />
        }
        label="Incorrect"
        value={incorrect}
        bgColor="bg-(--danger-D200)"
      />
    </div>
  );
};
